import { render, staticRenderFns } from "./ConfirmNewBlock.vue?vue&type=template&id=08dfd383&"
import script from "./ConfirmNewBlock.vue?vue&type=script&lang=js&"
export * from "./ConfirmNewBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports